import * as R from 'ramda';
import { columns } from './FormalGameRecord';

export const toTableRows = (pitchings, battings, rows) => {
  const players = pitchings.map((p) => ({
    ...p.player,
    position: '投',
    player_type: 'PITCHER',
  }));
  battings.forEach((batting) => {
    if (R.find((p) => p.uniqid === batting.player.uniqid, players)) {
      return false;
    }

    players.push({
      ...batting.player,
      position: '打',
      player_type: 'BATTER',
    });
    return;
  });
  return players.map((player) => {
    const records = {};
    console.log(columns);
    columns.forEach((column) => {
      console.log(column);
      if (!('updatable' in column)) {
        return false;
      }

      records[column.column] = !!R.find(
        (row) => row.player.uniqid === player.uniqid && row.value === column.column,
        rows,
      );
      return;
    });

    return {
      player: R.clone(player),
      ...records,
    };
  });
};
